import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Button,
  EditContainer,
  Flex,
  GridItem,
  H1WithBack,
  H2,
  ItemsGrid,
  PageFooter,
  PageWrapper,
} from 'styling/GlobalStyles'
import { CategoryModal } from 'components/Modal/CategoryModal'
import { Modal } from 'components/Modal/Modal'
import { NavBar } from 'components/NavBar/NavBar'
import { useSelector } from 'react-redux'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { EditIcon } from 'assets/icons/EditIcon'
import { RootState } from 'store'
import { cleanSingleClientMachine } from 'features/clientMachinery/clientMachinerySlice'
import { Pagination } from 'components/Pagination/Pagination'
import { getParams, handlePagination } from 'utils/helpers'
import { getMachineryCategories } from 'features/categories/machineryCategories'
import { ModalTypes } from 'types/global.interface'
import useQueryPagination from 'hooks/useQueryPagination'

export const FleetCategories = () => {
  const { machineryCategories, totalMachineryPages } = useSelector(
    (store: RootState) => store.machineryCategories,
  )
  const navigate = useNavigate()
  const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))

  const [modal, setModal] = useState<any>({
    open: false,
    edit: true,
    text: '',
    id: '',
    image: '',
    fields: [],
  })

  const ToggleEditModal = (text, id, image) => {
    setModal({ open: true, edit: true, text, id, image })
  }

  const ToggleAddModal = () => {
    setModal({ open: true, edit: false, text: '', id: '' })
  }

  useQueryPagination({
    fetchFunctions: [getMachineryCategories],
    cleanUpFunctions: [cleanSingleClientMachine],
    params,
  })

  return (
    <>
      <NavBar defaultValue={params.q} input placeholder='Search Categories...' setParams={setParams} />
      <PageWrapper>
        <Flex width='100%' between mb='16'>
          <H1WithBack title='Categories' arrow link='/machinery/fleet' />
          <Flex gap='1rem'>
            <Button orange onClick={() => navigate('/machinery/add')}>
              Add Machinery
            </Button>
            <Button orange onClick={ToggleAddModal}>
              Add Category
            </Button>
          </Flex>
        </Flex>

        {!machineryCategories.length ? (
          <NoItems title='Categories' />
        ) : (
          <>
            <H2 style={{ marginBottom: '1rem' }}>Machinery Categories</H2>
            <ItemsGrid columns={3}>
              {machineryCategories.map((category) => {
                const { name, id } = category
                return (
                  <GridItem noRightPadding key={id}>
                    <p onClick={() => navigate('/machinery/' + id.toString() + '?name=' + name)}>
                      {name}
                    </p>
                    <EditContainer
                      noBackground
                      onClick={() => ToggleEditModal(name, id, category?.getImagePresignedUrl)}
                    >
                      <span><EditIcon /></span>
                    </EditContainer>
                  </GridItem>
                )
              })}
            </ItemsGrid>
          </>
        )}
      </PageWrapper>
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams, 30)}
          pageCount={Math.ceil(totalMachineryPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>

      {modal.open && (
        <Modal black>
          <CategoryModal
            machinery
            text={modal.text}
            edit={modal.edit}
            id={modal.id}
            setParams={{
              type: ModalTypes.Delete,
              f: setParams,
              noItems: machineryCategories.length < 2,
            }}
            close={setModal}
          />
        </Modal>
      )}
    </>
  )
}
